import { loadSettings, saveSettings } from 'common/localStorage';
import { call } from 'redux-saga/effects';

export default function* localStorageSaveSettings({ payload }) {
  const { display } = payload;

  const data = yield call(loadSettings);

  const update = {
    ...data,
    displayArchivedProjects: display,
  };

  yield call(saveSettings, update);
}
